import React from 'react';
import _ from 'lodash';

import FieldTextArea from './FieldTextArea.jsx';
import FieldSelectRating from './FieldSelectRating.jsx';

export default function FieldTextAreaWithRating(props) {
  const description = !props.description ? '' : (
    <small>
      <br />({props.description})
    </small>
  );

  return (
    <div>
      <div className="space-between">
        <h6>{props.label}{description}</h6>
        <FieldSelectRating
          field={props.ratingField}
          nonTrackRating={props.nonTrackRating}
          limit={props.limit || 10}
          dropdownDescriptions={_.get(props, 'dropdownDescriptions')}
          overrideOptions={_.get(props, 'overrideOptions')}
          overrideDefaultValue={_.get(props, 'overrideDefaultValue')}
        />
      </div>

      <div>
        <FieldTextArea field={props.textAreaField} placeholder={props.placeholder} />
      </div>
    </div>
  );
}
